import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import Loader from 'src/components/Loader/Loader';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  max-width: 344px;
  margin: 0 auto;
  padding: 24px 0;
`;

const Dots = styled.div`
  width: 75px;
  height: 32px;
`;

// One fixed size shared by every wizard loading state so they never differ.
export const LoaderDots: React.FC = () => (
  <Dots>
    <Loader size="large" />
  </Dots>
);

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

interface FetchingStateProps {
  title: string;
  subtitle: string;
}

export const FetchingState: React.FC<FetchingStateProps> = ({ title, subtitle }) => (
  <Wrap>
    <LoaderDots />
    <Text>
      <Poppins px={16} weight={600} color="cflowerBlue">
        {title}
      </Poppins>
      <Poppins px={16} color="cflowerBlue" css="line-height: 1.7;">
        {subtitle}
      </Poppins>
    </Text>
  </Wrap>
);
